import cookie from "js-cookie";
import jwtDecode, { InvalidTokenError } from "jwt-decode";

import { Jwt } from "reducers/authReducer";

export type AuthCookie = {
  accessToken: string;
  refreshToken: string;
  mfaSetupRequired?: boolean;
  hasEmail?: boolean;
  hasPhone?: boolean;
};

// If we are running a development server pointing to a remote API
// then we need to keep localhost for the Cookie's domain.
const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN || "localhost";

export const setAuthCookie = (value: AuthCookie) => {
  let exp = 0;
  try {
    exp = jwtDecode<Jwt>(value.refreshToken || value.accessToken).exp;
  } catch (e) {
    console.error(e);
    if (!(e instanceof InvalidTokenError)) {
      throw e;
    }
  }

  cookie.set("auth", JSON.stringify(value), {
    expires: exp ? new Date(exp * 1000) : 1,
    domain: cookieDomain,
    priority: "high",
    secure: cookieDomain === "localhost" ? false : true,
  });
};

export const removeAuthCookie = () => {
  cookie.remove("auth", {
    domain: cookieDomain,
    priority: "high",
    secure: cookieDomain === "localhost" ? false : true,
  });

  // Delete legacy cookie too
  cookie.remove("auth");
};

export const getAnyAuthCookie = () => {
  const rawCookie = cookie.get("auth");
  if (!rawCookie) return null;

  // Sometimes the auth cookie is set via the BE
  // during a user impersonation event due to cookies
  // sent over the wire via the response headers.
  // In that case the cookie will be URL encoded.
  const uriDecoded = decodeURIComponent(rawCookie);
  return JSON.parse(uriDecoded);
};

export const getAuthCookie = () => getAnyAuthCookie() as AuthCookie;
